import styled from "styled-components";

export const StyledReportContent = styled.div`
.report-flex-item{
  display:flex;
  margin-bottom:10px;
  .key-title{
    padding-right:8px;
    color:var(--text-black);
    font-weight:500;
  }
  .key-value{
    color:var(--text-black)
  }
}
  .report-profile-img{
  img {width:100%}
  }
.report-no-image{
 color:var(--text-black);
 border:2px solid var(--text-black);
 font-size:22px;
 font-weight:500;
 min-height: 150px;
 min-width: 120px;
 max-width:100%;
 text-align:center;
 padding-top:30px;
 }
 .sign-form-check{
   padding-bottom: 30px;
   padding-left:4px;
   border-top:2px solid #000;
   white-space: nowrap;
 }
`
export const StyledReportContainer = styled.div`
    color:var(--text-black);
    .report-header{
      margin-bottom:15px;
    }
    .table-total-row{
    color:var(--text-black);
    font-weight:600;
    font-size:16px;
    }

    .report-top-header{
      text-align: center;
      margin-top:15px;
    }
    .report-primary-tile{
    font-size: 2.2rem;
    }
    .report-subtle-tile{
        font-size: 1.23rem;
    }
    .table-default{
      width:100%;
      margin-top:20px;
      thead th{
       background-color:rgba(0,0,0,0.09)
      }
      td,th{
      border:2px solid rgba(0,0,0,0.5);
      padding:2px 5px;
      }
    }
    .table-inner-header{
      --tbl-inner-header:#afe2f1;
      td{
      background-color:var(--tbl-inner-header);
      font-weight:600;
      }
    }
    .inner-total-row{
    text-align:right;
    font-weight:600;
    }
`